import { render } from "./FileNotFound.vue?vue&type=template&id=c0813266"
import script from "./FileNotFound.vue?vue&type=script&lang=js"
export * from "./FileNotFound.vue?vue&type=script&lang=js"

import exportComponent from "/home/borg/github/Heborg/booking-web/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__